import React from 'react'
import hoistNonReactStatic from 'hoist-non-react-statics'
import { getComponentName } from 'tools/react'

const bindEventListeners = (Component) => {
  class ComponentWithWindowEventListeners extends React.PureComponent {
    constructor (props) {
      super(props)
      this._eventListeners = []
    }

    componentDidMount () {
      this._eventListeners.forEach(({ event, callback, shouldTriggerOnMount }) => {
        window.addEventListener(event, callback)
        shouldTriggerOnMount && callback()
      })
    }

    componentWillUnmount () {
      this._eventListeners.forEach(({ event, callback }) => window.removeEventListener(event, callback))
    }

    registerEventListener = (event, callback, shouldTriggerOnMount = false) => {
      this._eventListeners.push({ event, callback, shouldTriggerOnMount })
    }

    render () {
      return <Component {...this.props} registerEventListener={this.registerEventListener} />
    }
  }
  hoistNonReactStatic(ComponentWithWindowEventListeners, Component)
  ComponentWithWindowEventListeners.displayName = `WithWindowEvents(${getComponentName(Component)})`
  return ComponentWithWindowEventListeners
}

export default bindEventListeners
